import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';

interface NoChatbotFoundProps {
  isWidget?: boolean;
}

export const NoChatbotFound: React.FC<NoChatbotFoundProps> = ({ isWidget = false }) => {
  const { user } = useAuth();

  if (isWidget) {
    return (
      <div className="flex flex-col items-center justify-center p-6 text-center">
        <h2 className="text-xl font-semibold mb-2">Chatbot Not Found</h2>
        <p className="text-gray-600">
          The requested chatbot is not available. This could be due to:
        </p>
        <ul className="list-disc text-left text-gray-600 mt-2 mb-4">
          <li>Invalid chatbot ID</li>
          <li>Chatbot has been deleted</li>
          <li>Chatbot is currently inactive</li>
        </ul>
        <p className="text-sm text-gray-500">
          Please contact the website administrator for assistance.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-6 text-center">
      <h2 className="text-xl font-semibold mb-2">No Chatbot Found</h2>
      <p className="text-gray-600 mb-4">
        {user ? (
          <>
            You don't have any chatbots yet. Create your first chatbot to get started!
          </>
        ) : (
          <>
            Please log in to view or create chatbots.
          </>
        )}
      </p>
      {user ? (
        <Link
          to="/dashboard/chatbots/new"
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          Create New Chatbot
        </Link>
      ) : (
        <Link
          to="/login"
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          Log In
        </Link>
      )}
    </div>
  );
}; 